import React, { useState } from 'react';import { List, Datagrid, DeleteButton, Edit, SelectInput, TextInput, Button, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, NumberInput, BooleanInput, FunctionField, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, Filter, BooleanField, TabbedShowLayout, Tab } from 'react-admin';import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';


import { TextFieldShow, TextHtmlShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { targets, modules, choicesCustomFieldsType } from './../common/constants';import { subscriptionModule } from './../common/utils';  
import { CustomFieldsOptionsList } from './../resources/custom_fields_options';import { RenderBoolean } from '../components/User';

import Box from '@material-ui/core/Box';

import { Link } from 'react-router-dom';

import { validateMaxLength, validateInteger, validateIntegerLowerOrEqualThan  } from './../components/Validator';


export const CustomFieldsList = (props) => {
  const translate = useTranslate();  
    
  return (
    
    <>
    <br/>
    <Typography variant="h5" className="grey8" align="center">
      {translate('custom_fields.main_menu_title')}              
    </Typography> 
    <Box sx={{ width: '100%', maxWidth: '90%', bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
    <TabbedShowLayout syncWithLocation={false}>
        <Tab label={translate('custom_fields.target_' + targets.USER)} fullWidth>
            <CustomFieldsListTarget target={targets.USER} />
        </Tab>
        { subscriptionModule(modules.FEDERATION) ?
            <Tab label={translate('custom_fields.target_' + targets.USER_FEDERATION)} fullWidth>
                <CustomFieldsListTarget target={targets.USER_FEDERATION} />
            </Tab>
        : null }
        { subscriptionModule(modules.FEDERATION) ?
            <Tab label={translate('custom_fields.target_' + targets.USER_FEDERATION_SPORTS)} fullWidth>
                <CustomFieldsListTarget target={targets.USER_FEDERATION_SPORTS} />
            </Tab>
        : null }
    }
    </TabbedShowLayout>
    </Box>
    </>
            
  );
};


export const CustomFieldsListTarget = (props) => {
  const translate = useTranslate();  
  
  let basePath='/custom_fields'; 
  let resource = 'custom_fields';  
  let events_id = props.events_id != null ? props.events_id : 0;
  
  return (
  <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ associations_id : localStorage.getItem('associations_id'), target: props.target, events_id: events_id }}  
        actions={props.show ?  <span/> : <ListActions target={props.target} events_id={events_id} />}    
        empty={props.show ?  <span/> : <ListActions target={props.target} events_id={events_id} />}        
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'priority', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<CustomFieldsDetails />} 
          className="expand-without-padding"
          >                                
          <FunctionField
            label={translate('custom_fields.name')}
            sortable={false}
            render={record => (
                    record.type==9 ? record.large_text : record.type==10 ? <TextHtmlShow source={record.large_text} html={true} /> : record.name            
            )}
          />          
          <FunctionField render={record => <span>{translate('custom_fields.type_' + record.type)}</span> } label={translate('custom_fields.type')} sortable={false}  />
          <BooleanField source="actived" label={translate('custom_fields.actived')} sortable={false} />  
        </Datagrid>        
      </List>
    </ResourceContextProvider>);
}
    

const MyFilter = (props) => {
    const translate = useTranslate(); 
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable />    
    </Filter>
);
};

export const CustomFieldsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>        
        
        { record.type < 9 ?
        <Grid item xs={4}>   
        <TextFieldShow source={record.name} label={translate('custom_fields.name')} />
        </Grid> 
        : record.type == 9 ?
        <Grid item xs={12}>   
        <TextFieldShow source={record.large_text} label={translate('custom_fields.type_' + record.type)} />
        </Grid> 
        : record.type == 10 ?
        <Grid item xs={12}>   
        <TextHtmlShow source={record.large_text} label={translate('custom_fields.type_' + record.type)} html={true} />
        </Grid> 
        : null }
        
        <Grid item xs={4}>   
          <TextFieldShow source={translate('custom_fields.type_'+record.type)} label={translate('custom_fields.type')} />
        </Grid>         
        <Grid item xs={4}>   
          { record.type == 1 || record.type == 2 || record.type == 3  ?
          <TextFieldShow source={record.max_length} label={translate('custom_fields.max_length')} />
          : null }
        </Grid> 
        { record.type < 9 ?
        <Grid item xs={4}>   
          <TextFieldShow source={<RenderBoolean source={record.required} />} label={translate('custom_fields.required')} />
        </Grid> 
        : null }
        <Grid item xs={4}>   
          <TextFieldShow source={<RenderBoolean source={record.actived} />} label={translate('custom_fields.actived')} />
        </Grid> 
        { record.target === targets.USER ?
        <Grid item xs={4}>   
          <TextFieldShow source={<RenderBoolean source={record.form_web} />} label={translate('custom_fields.form_web')} />
        </Grid> : null }
        <Grid item xs={4}>   
          <TextFieldShow source={record.priority} label={translate('custom_fields.priority')} />
        </Grid> 
      </Grid>
      
      { record.type == 7 || record.type == 8 ?
      <CustomFieldsOptionsList custom_fields_id={id} show={true} />
      : null }
      
    </div>
  );
};

const ListActions = (props) => {            
    const eventLimitReached = props.target === targets.EVENT && props.total >= 6;
    return (
    <TopToolbar>     
        <MyCreateButton {...props} disabled={eventLimitReached} />
    </TopToolbar>
    );
};

export const MyCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('custom_fields');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    if (props.disabled) return;
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                    
          redirect('/custom_fields/' + data.id);
        
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('custom_fields.create')} disabled={props.disabled}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('custom_fields.create')}
      >
        <DialogTitle>{translate('custom_fields.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id: localStorage.getItem('associations_id'), target: props.target, type: 1, events_id : props.events_id }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>  
                  <Grid item xs={12}>                                               
                    <SelectInput fullWidth source="type" label={translate('custom_fields.type')} validate={[required()]} choices={choicesCustomFieldsType(translate,props.target)} />
                  </Grid>
                  <FormDataConsumer>
                    {({ formData, ...rest }) => 
                      <>
                      { formData.type !== 9 && formData.type !== 10 ? (
                          <Grid item xs={12}>                                               
                            <TextInput fullWidth source="name" label={translate('custom_fields.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                          </Grid> 
                      ) : null }
                      { formData.type === 9 ? (
                          <Grid item xs={12}>    
                            <TextInput fullWidth source="large_text" label={translate('custom_fields.type_9')} validate={[validateMaxLength(1000,translate('common.validation.maxLength'))]} multiline />                            
                          </Grid> 
                      ) : null }
                      { formData.type === 10 ? (
                          <Grid item xs={12}>                                               
                            <TextInput fullWidth source="large_text" label={translate('custom_fields.type_10')} validate={[validateMaxLength(1000,translate('common.validation.maxLength'))]} multiline />
                          </Grid> 
                      ) : null }
                      </>
                    }
                  </FormDataConsumer>
                                   
                </Grid> 
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
    
  let linkBack = '/custom_fields';
  if (data && data.target && data.target==targets.EVENT)
      linkBack = '/events/' + data.events_id + '/custom_fields';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                { data && data.type && data.type < 9 && data.name ? data.name : data && data.type ? translate('custom_fields.type_' + data.type) : ''}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const CustomFieldsEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
    
  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated')); 
         
    if (data.target == targets.EVENT)
    {
        redirect('/events/' + data.events_id + '/custom_fields');       
    }else{
        redirect('/custom_fields');       
    }
    
  };
        
  return (

    <Edit 
      title={''} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path=""                 
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                    
                      <>
                      { formData.type < 9 ? (
                          <Grid item xs={12}>                                               
                            <TextInput fullWidth source="name" label={translate('custom_fields.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                          </Grid> 
                      ) : null }
                      { formData.type === 9 ? (
                          <Grid item xs={12}>    
                            <TextInput fullWidth source="large_text" label={translate('custom_fields.type_9')} validate={[validateMaxLength(1000,translate('common.validation.maxLength'))]} multiline />                            
                          </Grid> 
                      ) : null }
                      { formData.type === 10 ? (
                          <Grid item xs={12}>                                               
                            <TextInput fullWidth source="large_text" label={translate('custom_fields.type_10')} validate={[validateMaxLength(1000,translate('common.validation.maxLength'))]} multiline />
                          </Grid> 
                      ) : null }
                      </>
                      
                  <Grid item xs={3}>   
                    <SelectInput fullWidth source="type" label={translate('custom_fields.type')} validate={[required()]} choices={choicesCustomFieldsType(translate,formData.target)} disabled={true} />
                  </Grid> 
                  
                  { formData.type < 4 ? 
                  <Grid item xs={3}>   
                    { formData.type == 1 ? 
                        <NumberInput fullWidth source="max_length" label={translate('custom_fields.max_length')} validate={[validateInteger(),validateIntegerLowerOrEqualThan(100,translate('common.validation.maxValue'))]} />
                    : formData.type == 2 || formData.type == 3 ?
                        <NumberInput fullWidth source="max_length" label={translate('custom_fields.max_length')} validate={[validateInteger(),validateIntegerLowerOrEqualThan(1000,translate('common.validation.maxValue'))]} />
                    : null }
                  </Grid> 
                  : null }
                  
                  <Grid item xs={3}>   
                    <NumberInput fullWidth source="priority" label={translate('custom_fields.priority')} validate={[]} />
                  </Grid> 
                  
                  <Grid item xs={3}>   
                    <BooleanInput fullWidth source="actived" label={translate('custom_fields.actived')}  />
                  </Grid> 
                  
                  { formData.type < 9 ?
                  <Grid item xs={3}>   
                    <BooleanInput fullWidth source="required" label={translate('custom_fields.required')}  />
                  </Grid> 
                  : null }
                  
                  { formData.target == targets.USER ? 
                  <Grid item xs={3}>   
                    <BooleanInput fullWidth source="form_web" label={translate('custom_fields.form_web')}  />
                  </Grid> 
                  : null }          
                  
                  { formData.target == targets.USER_FEDERATION || formData.target == targets.USER_FEDERATION_SPORTS ? 
                  <Grid item xs={6}>   
                    <BooleanInput fullWidth source="form_annuary" label={translate('custom_fields.form_annuary')}  />
                  </Grid> 
                  : null }  
                  
                </Grid>                                

              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
        <FormTab
          label={translate('custom_fields.options')}
          contentClassName={classes.tab}
          path="options"                 
        > 
        
            <FormDataConsumer>
                {({ formData, ...rest }) => 
                <>     
                    { formData.type == 7 || formData.type == 8 ?
                    <CustomFieldsOptionsList custom_fields_id={id} />
                    : null }
                </>
                }
            </FormDataConsumer>
        
        </FormTab>
        
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  console.log(record);
  const title = record && record.type < 9 ? record.name : record && record.type < 11 ? record.large_text : "";
  return (<span>{translate('common.edit')} {title}</span>);
};

const FormToolbar = ({ id , ...props }) => {
    
  let redirect = '/custom_fields';
  const translate = useTranslate(); 
  
  if (props.record.target==targets.EVENT)
  redirect = '/events/' + props.record.events_id + '/custom_fields';  
          
  return (
    <Toolbar {...props} className="user_form_toolbar" >
      <SaveButton />
      <DeleteButton 
        redirect={redirect} 
        mutationMode="pessimistic"
        confirmTitle={translate('custom_fields.delete_title')}
        confirmContent={translate('custom_fields.delete_ask')} />
    </Toolbar>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});




